export enum CommunityAdminAction {
    Decline = 'decline',
    Approve = 'approve'
}